import { FilterChip, useQueryParams } from '@marqvision/shared';
import { useLogger } from '~/hooks';
import { useTab } from '~/pages/DomainNames/@hooks/useTab';
import { FilterQueryParams } from '~/pages/DomainNames/@types';

export const MXRecordsFilter = () => {
  const { currentTabGroup } = useTab();
  const { amplitudeLogging } = useLogger();

  const { params, setParams, removeParams } = useQueryParams<FilterQueryParams>();

  const isSelected = Boolean(params.mx_records_filter);

  const handleToggle = () => {
    amplitudeLogging('applied filter', {
      Type: 'mx records',
      Channel: 'domain names',
      Page: currentTabGroup.replace(/-/g, ' '),
    });

    if (isSelected) {
      removeParams('mx_records_filter');
    } else {
      setParams({ mx_records_filter: true }, { replace: true });
    }
  };

  return <FilterChip type="toggle" label="MX records" selected={isSelected} onClick={handleToggle} />;
};
